export default "__VITE_ASSET__BGzs4x48__"